import React from 'react';
import Color from 'color';
import './Widget.css'

class Widget extends React.Component {

  componentDidMount() {
    if(this.props.refreshInterval && this.props.onWidgetRefresh) {
      this.interval = setInterval(this.tick.bind(this), 1000 * this.props.refreshInterval);
    }
  }

  tick() {
    this.props.onWidgetRefresh();
  }

  componentWillUnmount() {
    if(this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {

    var color = Color(this.props.widgetColour);

    if(this.props.widgetGradient && this.props.position.y > 0) {
      color = color.darken((this.props.position.y + 1) / 10)
    }

    var style = {
      ...this.props.style,
      backgroundColor:color.rgb(),
      color:this.props.widgetTextColour
    }

    return (
      <div  className={"widget "+this.props.className}
            onMouseDown={this.props.onMouseDown}
            onMouseUp={this.props.onMouseUp}
            onTouchEnd={this.props.onTouchEnd}
            onTouchStart={this.props.onTouchStart}
            style={style}
            >
        {this.props.children}
      </div>
    )
  }
}

export default Widget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/Widget/Widget.js